<script>
  import alertify from "alertifyjs";
  import { ModalBody, ModalFooter, ModalHeader, Modal } from "sveltestrap";
  import backend from "../../../../../server";
  import moment from "moment";
  import SelectPlayers from "../player/SelectPlayers.svelte";
  import SelectGames from "../player/SelectGames.svelte";

  let tipo = false;
  let isAlet = false;
  let message = "";
  let mountCommon = 0;
  let isLoading = false;
  let loadingStakes = false;
  let configBonnus = { games: [], players: [], client: { id: null } };
  export let showNewFreeSpin;
  let bonusesList = [];
  let commonByCurrency = {};
  let stake = { siteCode: "latinsport21", currencies: null, games: [] };

  let bonuse = {
    playerId: "",
    siteCode: "latinsport21",
    currency: null,
    bonusRef: null,
    campaignRef: "universalsoft_pp_",
    type: "bets",
    requirement: {
      ttl: 3600,
      games: [],
      minStake: "1.00",
      minTotalBets: 1,
    },
    config: {
      ttl: 3600,
      games: [],
      stake: "",
      bets: 10,
      duration: 3600,
    },
    terms: "",
    termsUrl: "https://assets.apiusoft.com/DemoPlatform/t&c.pdf",
    timeExpires: "",
    generalTimeExpires: "",
  };

  const formatBonusesDates = () => {
    bonusesList.forEach((bonus) => {
      if (bonus.timeExpires) {
        bonus.timeExpires = moment(bonus.timeExpires).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      if (bonus.generalTimeExpires) {
        bonus.generalTimeExpires = moment(bonus.generalTimeExpires).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
    });
  };

  function validateBonuses(bonuses) {
  for (let i = 0; i < bonuses.length; i++) {
    const bonuse = bonuses[i];

    if (!bonuse.playerId || bonuse.playerId.trim() === "") {
      alertify.warning("Debe seleccionar un jugador.");
      return false;
    }
    if (!bonuse.currency || bonuse.currency.trim() === "") {
      alertify.warning("Debe seleccionar al menos una currency.");
      return false;
    }
    if (!bonuse.requirement.games || bonuse.requirement.games.length === 0) {
      alertify.warning("Debe seleccionar al menos un juego en requirement.");
      return false;
    }
    if (!bonuse.config.games || bonuse.config.games.length === 0) {
      alertify.warning("Debe seleccionar al menos un juego en config.");
      return false;
    }
    if (!bonuse.config.stake || bonuse.config.stake.trim() === "") {
      alertify.warning("Debe seleccionar Cantidad fija que debe apostarse en cada tiro.");
      return false;
    }
  }
  return true; 
}

  const saveFreeSpin = async () => {
    bonuse.config.ttl = bonuse.requirement.ttl;
    bonusesList = [normalizeBonusGames(bonuse)];
    formatBonusesDates();
    if (!validateBonuses(bonusesList)) return;
    isLoading = true;
    let resp = await backend.freespin.createFreeSpinsPtp({
      bonuses: bonusesList,
    });
    isAlet = true;
    tipo = resp.data.result ? true : false;
    message = tipo  ? "Se guardó correctamente." : resp.data?.error?.message || "Error desconocido.";
    if (tipo) onShowModal();
  };

  const onShowModal = () => (showNewFreeSpin = !showNewFreeSpin);

  let campaignRefEditable =
    bonuse.campaignRef.split("universalsoft_pp_")[1] || "";
  function handleInput(event) {
    campaignRefEditable = event.target.value.replace(/\s/g, ""); // Elimina los espacios
    bonuse.campaignRef = "universalsoft_pp_" + campaignRefEditable;
  }

  function normalizeBonusGames(bonus) {
  if (bonus.requirement?.games) {
    bonus.requirement.games = bonus.requirement.games.map(gameid =>
      gameid.replace("_ptp", "")
    );
  }
  if (bonus.config?.games) {
    bonus.config.games = bonus.config.games.map(gameid =>
      gameid.replace("_ptp", "")
    );
  }
  return bonus;
}

  const requestStakes = async () => {
  stake.currencies = [bonuse.currency];
  stake.games = [...bonuse.config.games]; // 🔹 usa solo los seleccionados actuales

  if (!stake.siteCode || stake.siteCode.trim() === "") {
    return success.alert("El siteCode es obligatorio.");
  }
  if (!bonuse.currency || bonuse.currency.trim() === "") {
    return alertify.alert("Debe seleccionar al menos una currency.");
  }
  if (!stake.games || stake.games.length === 0) {
    return alertify.alert("Debe seleccionar al menos un juego.");
  }

  // limpiar sufijo si aplica
  stake.games = stake.games.map((gameid) => gameid.replace("_ptp", ""));

  try {
    let response = await backend.freespin.stakeGeneratorSave(stake);
    let responseError = response?.data?.error;
    let responseSuccess = response?.data?.result;

    if (responseError) {
      alertify.error(
        "Ocurrió un error al sincronizar: " + responseError.message
      );
      return;
    }

    const common = getCommonByCurrency(responseSuccess);
    commonByCurrency = common;

    mountCommon = Object.values(commonByCurrency).flat().length;
    console.log("Montos comunes encontrados:", mountCommon);
  } finally {
    loadingStakes = false;
  }
};


  function getCommonByCurrency(result) {
  if (!result || Object.keys(result).length === 0) {
    return {};
  }
  const currencies = Array.from(
    new Set(Object.values(result).flatMap((game) => Object.keys(game)))
  );
  const commonByCurrencyLocal = {};
  currencies.forEach((curr) => {
    const bonusArrays = Object.values(result)
      .map((game) => game[curr]?.bonusValid)
      .filter(Boolean).map(arr => Array.from(arr)); 

    if (bonusArrays.length === 0) {
      console.log(`No hay bonusValid para la currency ${curr}`);
      return;
    }
    const common = bonusArrays.reduce((acc, arr) => acc.filter((x) => arr.includes(x)));
    commonByCurrencyLocal[curr] = common;
  });
  return commonByCurrencyLocal;
}

 
  let isSelectPlayer = false;
  const selectPlayers = () => {
    isSelectPlayer = true;
  };
  let isSelectGames = false;
  const selectGames = () => {
    isSelectGames = true;
  };

  function playesExtraction(updatedConfig) {
    configBonnus = updatedConfig;
    isSelectPlayer = false;
    console.log("Player Recivied: ", configBonnus);
  }
  function gamesExtraction(updatedConfig) {
    configBonnus = updatedConfig;
    isSelectGames = false;
    console.log("Games Recivied: ", configBonnus);
  }

  const handlePlayerChange = (event) => {
    const username = event.target.value;
    const player = configBonnus.players.find((p) => p.username === username);
    if (player) bonuse.currency = player.currency;
    else bonuse.currency = null;
  };

  function toggleGame(game) {
  game.selected = !game.selected;

  // 🔹 recalcular stake.games con solo los seleccionados
  stake.games = configBonnus.games
    .filter(g => g.selected)
    .map(g => g.gameid);

  // 🔹 sincronizar con bonuse
  bonuse.config.games = [...stake.games];
  bonuse.requirement.games = [...stake.games];

  // 🔹 resetear montos cuando hay cambios
  mountCommon = 0;
  commonByCurrency = {};

  console.log("Stake actualizado:", stake);
  console.log("Bonuse actualizado:", bonuse);
}


 
</script>

<Modal isOpen={showNewFreeSpin} toggle={onShowModal} size="xl">
  <ModalHeader toggle={onShowModal}>
    CONFIGURACIÓN DE FREESPIN
  </ModalHeader>
  <ModalBody>
    <div class="freeSpin-modal">
      <!-- BONUS SECTION -->
      <section>
        <h5>Rondas Gratuitas.</h5>

        <div class="list-inputs">
          <!-- CampaignRef (ID de Campaña) -->
          <label>
            Referencia de la Campaña:
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                value="universalsoft_pp_"
                disabled
              />
              <input
                type="text"
                class="form-control"
                bind:value={campaignRefEditable}
                on:input={handleInput}
                required
              />
            </div>
          </label>

          <!-- Player ID -->
          <label>
            Jugador:
            <div class="input-group mb-3">
              <select
                bind:value={bonuse.playerId}
                class="form-control"
                required
                on:change={handlePlayerChange}
              >
                <option value="" disabled selected>Selecciona un jugador</option
                >
                {#each configBonnus.players ?? [] as player}
                  <option value={player.username}
                    >{player.firstname}
                    {player.lastname} - ({player.username_origin})</option
                  >
                {/each}
              </select>
              <button
                on:click={() => selectPlayers()}
                class="btn btn-outline-secondary btn-sm"
              >
                <i class="fa fa-plus-circle" aria-hidden="true"></i> Nuevos
              </button>
            </div>
          </label>
          <!-- Currency -->
          <label>
            Moneda:
            <input class="form-control" bind:value={bonuse.currency} disabled />
          </label>

          <!-- Site Code -->
          <label>
            Código del Sitio:
            <input
              class="form-control"
              bind:value={bonuse.siteCode}
              required
              disabled
            />
          </label>

          <!-- games, -->

          <div class="card entities-list">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <p class="mb-0">Juegos agregados</p>
              <div class="d-flex align-items-center gap-2">
                <span class="badge bg-secondary rounded-pill">
                  {configBonnus.games.length}
                </span>
                <button
                  on:click={() => selectGames()}
                  class="btn btn-outline-secondary btn-sm"
                >
                  <i class="fa fa-plus-circle" aria-hidden="true"></i> Nuevos
                </button>
              </div>
            </div>

            <div class="card-body" style="max-height: 150px; overflow-y: auto;">
              {#if configBonnus.games.length > 0}
                <div class="list-group">
                  {#each configBonnus.games ?? [] as game}
                    <label class="list-group-item d-flex align-items-center">
                      <input
                        type="checkbox"
                        class="form-check-input me-2"
                        checked={game.selected}
                        on:change={() => toggleGame(game)}
                      />
                      <span>{game.name}</span>
                    </label>
                  {/each}
                </div>
              {:else}
                <p class="text-center text-muted mb-0">
                  No hay juegos seleccionados.
                </p>
              {/if}
            </div>
          </div>
          <!-- monto a apostar por cada bono -->
          <label>
            Cantidad fija que debe apostarse en cada tiro
            <div class="input-group mb-3">
               <!-- Selector de montos comunes -->
              <select class="form-select" disabled={configBonnus.games.length === 0}
              bind:value={bonuse.config.stake}>
              <option value="" disabled selected>Selecciona monto ({mountCommon})</option>
                {#each Object.entries(commonByCurrency) as [currency, amounts]}
                  <optgroup label={currency}>
                    {#each amounts as amount}
                      <option value={amount}>{amount}</option>
                    {/each}
                  </optgroup>
                {/each}
              </select>

              <button
                on:click={requestStakes}
                class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
                type="button"
                disabled={loadingStakes}
              >
                {#if loadingStakes}
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Cargando...
                {:else}
                  <i class="fa fa-sync-alt"></i>
                  Sincronizar
                {/if}
              </button>
            </div>
            <span class="description">
              Solo se muestran los montos comunes a los juegos seleccionados.
              <b>Ejemplo:</b> [J1=10,20], [J2=30,20], [J3=20,80] → el monto
              común es <b>20</b>.
            </span>
          </label>
        </div>
      </section>

      <!-- REQUIREMENTS SECTION -->
      <section>
        <h5>Requisitos y Configuraciones.</h5>
        <div class="list-inputs">
          <!-- Type -->
          <label>
            tipo:
            <select class="form-control" bind:value={bonuse.type} required>
              <option value="bets">Bets</option>
              <option value="infinity">Infinity</option>
              <option value="sure_win">Sure Win</option>
            </select>
          </label>

          <!-- Requirement TTL -->
          <label>
            Tiempo para completar tras reclamar el bono
            <input
              class="form-control"
              type="number"
              bind:value={bonuse.requirement.ttl}
              required
              min="0"
            />
          </label>
          
          <!-- Min Total Bets -->
          <label>
            Cantidad mínima de apuestas totales necesarias para acceder al
            Bonus:
            <input
              class="form-control"
              type="number"
              bind:value={bonuse.requirement.minTotalBets}
              required
              min="0"
              disabled
            />
          </label>

          <!-- Min Stake -->
          <label>
            Apuesta mínima que el jugador debe realizar para acceder a la ronda gratis:
            <input
              class="form-control"
              type="number"
              bind:value={bonuse.requirement.minStake}
              required
              min="0"
              step="0.01"
            />
          </label>
           <!-- Bets -->
           <label>
            El número de apuestas del bono (solo para bonos de tipo "bets"):
            <input
              class="form-control"
              type="number"
              bind:value={bonuse.config.bets}
              required
              min="0"
            />
          </label>

          <!-- Time Expires -->
          <label>
            Fecha en que el bono deja de ser válido para ser reclamado:
            <input
              class="form-control"
              type="datetime-local"
              bind:value={bonuse.timeExpires}
              required
            />
          </label>
           <!-- Mostrar input de duración solo si el tipo es "infinity" -->
           {#if bonuse.type === "infinity"}
           <label>
             Duración del bono (en segundos):
             <input
               class="form-control"
               type="number"
               bind:value={bonuse.config.duration}
               required
               min="0"
             />
           </label>
         {/if}

        </div>
      </section>

      <!-- TERMS SECTION -->
      <section>
        <h5>Terms</h5>
        <div class="list-inputs">
          <!-- Terms -->
          <label>
            Términos y condiciones del bono en formato de texto:
            <textarea class="form-control" bind:value={bonuse.terms} required
            ></textarea>
          </label>

          <!-- Terms URL -->
          <label>
            URL que lleva a los términos y condiciones del bono.
            <input
              class="form-control"
              type="url"
              bind:value={bonuse.termsUrl}
              required
            />
          </label>
          <!-- General Time Expires -->
          <label>
            fecha en la que el bono deja de ser válido completamente:
            <input
              class="form-control"
              type="datetime-local"
              bind:value={bonuse.generalTimeExpires}
              required
            />
          </label>
        </div>
      </section>
      <div class="row">
        <div class="col-md-12">
          {#if isAlet}
            <div
              class={`alert mt-2 alert-${tipo ? "success" : "danger"} alert-dismissible fade show`}
              role="alert"
            >
              <strong>{tipo ? "¡Éxito!" : "¡Error!"} {message}</strong>
              <button
                type="button"
                class="btn-close"
                on:click={() => (isAlet = false)}
              ></button>
            </div>
          {/if}
        </div>
      </div>
    </div>
  </ModalBody>
  <ModalFooter>
    <button class="btn btn-primary" on:click={() => saveFreeSpin(bonuse)}>
      Guardar
    </button>
  </ModalFooter>
</Modal>

{#if isSelectPlayer}
  <SelectPlayers {configBonnus} onSave={playesExtraction} bind:isSelectPlayer />
{/if}
{#if isSelectGames}
  <SelectGames {configBonnus} onSave={gamesExtraction} bind:isSelectGames />
{/if}

<style>
  .freeSpin-modal {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .list-inputs {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
  }
  .description {
    font-style: italic;
    font-size: 0.8rem;
    color: gray;
  }
</style>
